/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SavedSearchSchema } from './savedSearchSchema';
import type { SearchRunSchema } from './searchRunSchema';

export interface SearchWithRunResponseSchema {
  search: SavedSearchSchema;
  latest_run?: SearchRunSchema | null;
  seeded_message?: string | null;
}
